import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import GroupsIcon from '@mui/icons-material/Groups';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import PaperComponent from "../../components/PaperComponent";
import {
  obterUsuarios,
  obterUsuariosPorTextoDeBusca,
  cadastrarUsuario,
  atualizarUsuario,
  excluirUsuario,
} from "../../services/usuarios.service";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext";
import UsuarioForm from "src/forms/UsuarioForm";
import {
  atualizarPermissoesUsuario,
  getPermissoesUsuarios,
  getPermissoes,
  buscarGruposUsuarios,
  buscarGruposUsuariosPorTexto,
  editarGrupoUsuario,
  excluirGrupoUsuario,
  inserirGrupoUsuario
} from "../../services/api-autenticacao.service";
import GruposUsuariosForm from "src/forms/GruposUsuariosForm";

const GruposUsuarios = () => {

  const navigate = useNavigate();

  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [userPermissionsData, setUserPermissionsData] = useState([]);
  const [editRowPermissionsData, setEditRowPermissionsData] = useState([]);
  const [msg, setMsg] = useState("");
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);

  const columns = [
    { id: "idGrupoUsuario", label: "ID", field: "idGrupoUsuario" },
    { id: "descricao", label: "Descrição", field: "descricao" },
    { id: "numUsuarios", label: "Qtd. Usuarios", field: "numUsuarios" },
    { id: "ativo", label: "Ativo", field: "ativo" },
  ];

  const handleOpenModal = async (rowData) => {
    if (rowData.idGrupoUsuario !== undefined) {
      setEditRowData(rowData)
      setEditRowPermissionsData(await obterPermissoesUsuario(rowData.idGrupoUsuario))
    }
    else {
      setEditRowData({});
      setEditRowPermissionsData([])
    }
    setOpenModal(true);
  };

  const obterPermissoesUsuario = async (idUsuario) => {
    try {
      const response = await getPermissoesUsuarios(idUsuario);
      return response.permissoes;
    } catch (err) {
      if (err.response.status === 404 && err.response.data.sucesso === false) {
        return [];
      } else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
      }
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async (data) => {
    setLoading(true);
    try {
      if (!editRowData.idGrupoUsuario) {
        const body = {
          grupo: {
            descricao: data.usuario.descricao
          }
        }
        const response = await inserirGrupoUsuario(body)
        await atualizarPermissoesUsuario(response.idGrupoUsuario, { permissoes: data.permissoes });
        setMsg('Cadastro realizado com sucesso!')
      }
      else {
        const body = {
          grupo: {
            descricao: data.usuario.descricao,
            ativo: data.usuario.ativo
          }
        }
        await editarGrupoUsuario(editRowData.idGrupoUsuario, body)
        await atualizarPermissoesUsuario(editRowData.idGrupoUsuario, { permissoes: data.permissoes });
        setMsg('Edição realizada com sucesso!')
      }
      const response = await buscarGruposUsuarios();
      setData(response.grupos);
      handleOpenSnackbarSucesso()
      handleCloseModal()
    } catch (error) {
      setMsg(error.response.data.mensagem);
      handleOpenSnackbarErro()
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await excluirGrupoUsuario(editRowData.idGrupoUsuario)
      const response = await buscarGruposUsuarios();
      setData(response.grupos);
      setMsg('Grupo de Usuários excluído com sucesso! ')
      handleOpenSnackbarSucesso()
      handleCloseDialogExclusao()
    } catch (error) {
      setMsg(error.response.data.mensagem);
      handleOpenSnackbarErro()
      handleCloseDialogExclusao()
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchGruposUsuarios = async () => {
      setLoading(true);
      try {
        const response = await buscarGruposUsuarios();
        const responsePermissoes = await getPermissoes();
        setUserPermissionsData(responsePermissoes.permissoes);
        setData(response.grupos);
      } catch (error) {
        setMsg(error.response.data.mensagem);
        handleOpenSnackbarErro()
        handleCloseDialogExclusao()
      }
      setLoading(false);
    };

    fetchGruposUsuarios();
  }, [navigate]);

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await buscarGruposUsuariosPorTexto(event.target.value);
      setData(response.grupos);
    } catch (error) {
      setMsg(error.response.data.mensagem);
      handleOpenSnackbarErro()
      handleCloseDialogExclusao()
    }
    setLoading(false);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <GroupsIcon fontSize="30px" />
        }
        headerTitle={"Grupos de Usuários"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        modalButtonLabel={"Novo"}
      />

      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        orderColumn={'idGrupoUsuario'}
        onEditButtonClick={handleOpenModal}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "140%", // Defina a largura desejada
            height: "100vh",
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <GroupsIcon className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData.idUsuario
                ? "Edição de Usuário"
                : "Cadastro de Usuário"}
            </h1>
          </div>
        </DialogTitle>
        <GruposUsuariosForm
          userValues={Object.assign({}, editRowData)}
          userPermissionData={userPermissionsData}
          userPermissionValues={[...editRowPermissionsData]}
          onSubmit={handleSaveChanges}
          onClose={handleCloseModal}
          className={styles.popupContent}
        >
        </GruposUsuariosForm>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente o Grupo de Usuários {editRowData.descricao}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default GruposUsuarios;
